import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnackbarService, SnackbarData } from '../../../core/services/snackbar.service';
import { Subscription } from 'rxjs';
import { trigger, style, animate, transition } from '@angular/animations';
import { HugeiconsIconComponent } from '@hugeicons/angular';
import { CheckmarkCircle01Icon, AlertCircleIcon, InformationCircleIcon, Alert02Icon, Cancel01Icon } from '@hugeicons/core-free-icons';

@Component({
    selector: 'app-snackbar',
    standalone: true,
    imports: [CommonModule, HugeiconsIconComponent],
    templateUrl: './snackbar.component.html',
    styleUrl: './snackbar.component.scss',
    animations: [
        trigger('snackbarAnimation', [
            transition(':enter', [
                style({ transform: 'translateY({{startPos}})', opacity: 0 }),
                animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateY(0)', opacity: 1 }))
            ], { params: { startPos: '100%' } }),
            transition(':leave', [
                animate('200ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateY({{endPos}})', opacity: 0 }))
            ], { params: { endPos: '100%' } })
        ])
    ]
})
export class SnackbarComponent implements OnInit, OnDestroy {
    snackbar: SnackbarData | null = null;
    private subscription: Subscription = new Subscription();
    private timeoutId: any;

    // Icons
    successIcon = CheckmarkCircle01Icon;
    errorIcon = AlertCircleIcon;
    infoIcon = InformationCircleIcon;
    warningIcon = Alert02Icon;
    closeIcon = Cancel01Icon;

    constructor(private snackbarService: SnackbarService) { }

    ngOnInit(): void {
        this.subscription = this.snackbarService.snackbar$.subscribe(data => {
            this.snackbar = data;
            if (data) {
                if (this.timeoutId) clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(() => {
                    this.close();
                }, data.duration || 5000);
            }
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        if (this.timeoutId) clearTimeout(this.timeoutId);
    }

    getAnimationParams() {
        if (!this.snackbar?.position) return { value: '', params: { startPos: '100%', endPos: '100%' } };

        const isTop = this.snackbar.position.startsWith('top');
        return {
            value: '',
            params: {
                startPos: isTop ? '-100%' : '100%',
                endPos: isTop ? '-100%' : '100%'
            }
        };
    }

    close(): void {
        this.snackbarService.hide();
    }
}
